/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check whether a text and background colour pair meets WCAG accessibility contrast rules. Pick two colours and see the ratio plus AA/AAA pass or fail for normal and large text.`)
};

const es_cc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte texto entre casos de letras al instante — mayúsculas, minúsculas, título, oración, camelCase, snake_case y más. Copia cualquier resultado con un clic.`)
};

const de_cc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konvertiere Text sofort zwischen Schreibweisen — UPPERCASE, lowercase, Title, Sentence, camelCase, snake_case und mehr. Kopiere jedes Ergebnis mit nur einem Klick.`)
};

const nl_cc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet tekst onmiddellijk om tussen lettertypes — HOOFDLETTERS, kleine letters, titel, zin, camelCase, snake_case en meer. Kopieer elk resultaat met één klik.`)
};

const fr_cc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez le texte entre différentes casses instantanément — majuscules, minuscules, titre, phrase, camelCase, snake_case et bien d'autres. Copiez n'importe quel résultat en un clic.`)
};

const it_cc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti il testo tra diverse maiuscole istantaneamente — maiuscoli, minuscoli, titolo, frase, camelCase, snake_case e altro. Copia qualsiasi risultato con un solo clic.`)
};

const pt_br2_cc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta texto entre casos de letra instantaneamente — maiúsculas, minúsculas, título, frase, camelCase, snake_case e mais. Copie qualquer resultado com um clique.`)
};

const pt_cc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta o texto entre casos de letras instantaneamente — maiúsculas, minúsculas, título, sentença, camelCase, snake_case e muito mais. Copie qualquer resultado com um clique.`)
};

const ja_cc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを文字ケース間で瞬時に変換 — uppercase、lowercase、title、sentence、camelCase、snake_case など。1クリックで任意の結果をコピー。`)
};

const zh_cc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即在多种字母大小写之间转换文本——全大写、全小写、标题格式、句首大写、camelCase、snake_case 等。一键复制任意结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_intro", locale)
	if (locale === "en") return en_cc_intro(inputs)
	if (locale === "es") return es_cc_intro(inputs)
	if (locale === "de") return de_cc_intro(inputs)
	if (locale === "nl") return nl_cc_intro(inputs)
	if (locale === "fr") return fr_cc_intro(inputs)
	if (locale === "it") return it_cc_intro(inputs)
	if (locale === "pt-BR") return pt_br2_cc_intro(inputs)
	if (locale === "pt") return pt_cc_intro(inputs)
	if (locale === "ja") return ja_cc_intro(inputs)
	return zh_cc_intro(inputs)
};